import { render, staticRenderFns } from "./admin-expedientesEdit.vue?vue&type=template&id=3a4ff7d8&"
import script from "./admin-expedientesEdit.vue?vue&type=script&lang=js&"
export * from "./admin-expedientesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports